import { BaseEntity } from './base.entity';
import { User } from './user.entity';
import {
  CommunicationStyle,
  InfluenceStyle,
  MotivationStyle,
  EmotionalAwarenessStyle,
} from '../enum/affinity-mcq.enum';
import { Type } from 'class-transformer';

export class AffinityMcq extends BaseEntity {
  isMethodicalPlanner!: boolean;
  hasDetailedApproach!: boolean;
  needsGuidelines!: boolean;
  hasPerseverance!: boolean;
  isChangeOriented!: boolean;
  emotionalAwarenessStyle!: EmotionalAwarenessStyle;
  isSociable!: boolean;
  hasQuickPace!: boolean;
  isChallengeDriven!: boolean;
  hasEmotionalControl!: boolean;
  hasResiliency!: boolean;
  communicationStyle!: CommunicationStyle[];
  influenceStyle!: InfluenceStyle[];
  motivationStyle!: MotivationStyle[];
  @Type(() => User)
  user?: User;
}
